(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
function initModifitArticles(scope) {
  scope.querySelectorAll('[data-mf-journal]').forEach(article => {
    if (article.dataset.journalReady) return;
    article.dataset.journalReady = 'true';
    const body = article.querySelector('[data-journal-body]');
    const contents = article.querySelector('[data-journal-contents]');
    if (!body) return;
    body.querySelectorAll('p').forEach(p => {
      if (!p.textContent.trim() && !p.querySelector('img,iframe,video,audio,svg,button,input')) p.hidden = true;
    });
    body.querySelectorAll('iframe').forEach(frame => {
      const width = Number(frame.getAttribute('width'));
      const height = Number(frame.getAttribute('height'));
      if (width > 0 && height > 0) {
        frame.style.aspectRatio = width + ' / ' + height;
        frame.style.width = height > width ? 'min(100%,360px)' : '100%';
        frame.style.height = 'auto';
      }
      frame.setAttribute('loading', 'lazy');
      frame.setAttribute('allowfullscreen', '');
    });
    const headings = Array.from(body.querySelectorAll('h2,h3')).filter(h => h.textContent.trim());
    if (contents && headings.length > 1) {
      const list = contents.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = article.closest('[id]').id + '-heading-' + index;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      contents.hidden = false;
    }
  });
}
initModifitArticles(document);
document.addEventListener('shopify:section:load', event => initModifitArticles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
function initModifitBlog(scope){
  scope.querySelectorAll('[data-mf-blog]').forEach(root=>{
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const filters=root.querySelector('[data-blog-filters]');
    if(!filters) return;
    const cards=Array.from(root.querySelectorAll('[data-blog-card]'));
    const feature=root.querySelector('[data-featured]');
    filters.querySelectorAll('[data-filter]').forEach(button=>{
      const topic=button.dataset.filter;
      if(topic!=='all'&&!cards.some(card=>card.dataset.topic===topic)){button.hidden=true;return;}
      button.addEventListener('click',()=>{
        filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        if(feature)feature.hidden=topic!=='all';
        cards.forEach(card=>{
          card.classList.toggle('mf-blog__card--featured',topic==='all'&&card.hasAttribute('data-featured-card'));
          card.hidden=topic!=='all'&&card.dataset.topic!==topic;
        });
        root.querySelector('[data-blog-status]').textContent=button.textContent.trim();
      });
    });
    filters.hidden=false;
  });
}
initModifitBlog(document);
document.addEventListener('shopify:section:load',event=>initModifitBlog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modifit-custom-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialiseSizeGuide = (story) => {
    const dialog = story.querySelector('[data-mfc-size-dialog]');
    if (!dialog || dialog.dataset.bound) return;
    const main = document.querySelector('.shopify-section--main-product');
    const trigger = main?.querySelector('[data-mfc-size-trigger]');
    if (!trigger || typeof dialog.showModal !== 'function') return;
    dialog.dataset.bound = 'true';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    const status = dialog.querySelector('[data-mfc-size-status]');
    const content = dialog.querySelector('[data-mfc-size-content]');
    let loaded = false;
    let loading = false;
    let previousOverflow = '';
    let opener;
    const make = (tag, text, className) => {
      const element = document.createElement(tag);
      if (text) element.textContent = text;
      if (className) element.className = className;
      return element;
    };
    const loadGuide = async () => {
      if (loaded || loading) return;
      loading = true;
      status.hidden = false;
      status.textContent = 'Loading the size guide…';
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const url = new URL(trigger.href, location.href);
        if (url.origin !== location.origin) throw new Error('External guide');
        const response = await fetch(url.href, {signal:controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Guide unavailable');
        const source = new DOMParser().parseFromString(await response.text(), 'text/html');
        const chart = source.querySelector('#mfs-chart table');
        const steps = source.querySelector('#mfs-measure .mfs-steps');
        if (!chart || !steps) throw new Error('Guide format changed');
        const headings = [...chart.querySelectorAll('thead th')];
        const productName = story.dataset.productName || '';
        const type = /lever/i.test(productName) ? 'Lever Powerlifting Belt'
          : /prong/i.test(productName) ? 'Prong Powerlifting Belt'
          : /weight.?lifting/i.test(productName) ? 'Weightlifting Belt' : '';
        const column = headings.findIndex(cell => cell.textContent.trim() === type);
        const fragment = document.createDocumentFragment();
        if (column > 0) {
          const iconClass = type === 'Lever Powerlifting Belt' ? 'lever' : type === 'Prong Powerlifting Belt' ? 'prong' : 'wl';
          const approvedImage = source.querySelector('.mfs-icon-' + iconClass + ' img');
          if (approvedImage) {
            const imageUrl = new URL(approvedImage.getAttribute('src'), url.href);
            if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
              const figure = make('figure', '', 'mfc-size-belt');
              const crop = make('div', '', 'mfc-size-belt__crop mfc-size-belt__crop--' + iconClass);
              const image = make('img');
              image.src = imageUrl.href;
              image.alt = type + ' outline illustration';
              image.width = 1774;
              image.height = 887;
              image.decoding = 'async';
              image.addEventListener('error', () => figure.remove(), {once:true});
              crop.append(image);
              figure.append(crop, make('figcaption', type));
              fragment.append(figure);
            }
          }
        }
        fragment.append(make('h3', 'How to measure'));
        const intro = source.querySelector('#mfs-measure .mfs-intro');
        if (intro) fragment.append(make('p', intro.textContent.trim()));
        const list = make('ol');
        for (const original of steps.querySelectorAll('li')) {
          const item = make('li');
          item.append(make('strong', original.querySelector('h3')?.textContent.trim()));
          item.append(make('p', original.querySelector('p')?.textContent.trim()));
          list.append(item);
        }
        fragment.append(list);
        fragment.append(make('h3', column > 0 ? type : 'Belt size chart'));
        const advice = source.querySelector('.mfs-finder-note');
        if (advice) fragment.append(make('p', advice.textContent.trim()));
        const rows = [...chart.querySelectorAll('tbody tr')];
        if (column > 0) {
          const selectId = dialog.id + '-range';
          const label = make('label', 'Your waist / stomach range');
          label.htmlFor = selectId;
          const select = make('select');
          select.id = selectId;
          const placeholder = make('option', 'Choose your measurement range');
          placeholder.value = '';
          select.append(placeholder);
          rows.forEach((row, index) => {
            const option = make('option', [...row.cells[0].childNodes].map(node => node.textContent.trim()).filter(Boolean).join(' '));
            option.value = String(index);
            select.append(option);
          });
          const result = make('p', '', 'mfc-size-result');
          result.setAttribute('role', 'status');
          select.addEventListener('change', () => {
            const row = select.value === '' ? null : rows[Number(select.value)];
            const size = row?.cells[column]?.textContent.trim();
            result.textContent = !size ? '' : size === '-' || size === 'Ask us'
              ? 'Contact us for help with this measurement.'
              : 'Recommended size: ' + size;
          });
          fragment.append(label, select, result);
          fragment.append(make('p', 'Check that this size is available on your product. If overlapping ranges give different recommendations, contact us before ordering.'));
        }
        const details = make('details');
        details.append(make('summary', 'View the size chart'));
        const tableWrap = make('div', '', 'mfc-size-dialog__table');
        const table = make('table');
        const caption = chart.querySelector('caption');
        if (caption) table.append(make('caption', caption.textContent.trim()));
        const kept = column > 0 ? [0, column] : headings.map((_, index) => index);
        const thead = make('thead');
        const headerRow = make('tr');
        kept.forEach(index => {
          const cell = make('th', headings[index].textContent.trim());
          cell.scope = 'col';
          headerRow.append(cell);
        });
        thead.append(headerRow);
        const tbody = make('tbody');
        rows.forEach(original => {
          const row = make('tr');
          kept.forEach(index => {
            const sourceCell = original.cells[index];
            const cell = make(index === 0 ? 'th' : 'td');
            if (index === 0) cell.scope = 'row';
            for (const node of sourceCell.childNodes) {
              if (node.nodeType === Node.TEXT_NODE) cell.append(document.createTextNode(node.textContent));
              else if (node.nodeName === 'SMALL') cell.append(make('small', node.textContent));
              else cell.append(document.createTextNode(node.textContent));
            }
            row.append(cell);
          });
          tbody.append(row);
        });
        table.append(thead, tbody);
        tableWrap.append(table);
        details.append(tableWrap);
        fragment.append(details);
        content.replaceChildren(fragment);
        status.hidden = true;
        loaded = true;
      } catch {
        status.textContent = 'The size chart could not load. Use the full size guide link below, or close and reopen this popup to try again.';
      } finally {
        clearTimeout(timer);
        loading = false;
      }
    };
    trigger.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      opener = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      loadGuide();
    });
    dialog.querySelector('[data-mfc-size-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus({preventScroll:true});
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(story) && dialog.open) dialog.close();
    });
  };

  const initialise = (story) => {
    const main = document.querySelector('.shopify-section--main-product');
    if (!main || story.dataset.ready === 'true') return;
    const buy = main.querySelector('[data-block-type="buy-buttons"]');
    const root = buy?.querySelector('[data-modifit-simple-order]');
    const chooser = root?.querySelector('[data-modifit-route-chooser]');
    const builder = buy?.querySelector('[data-modifit-builder-shell]');
    if (!root || !chooser || !builder) return;
    story.dataset.ready = 'true';
    main.classList.add('mfc-main');
    buy.classList.add('mfc-buy');
    const insert = (name, target, prepend = false) => {
      const content = story.querySelector(`[data-mfc-${name}]`)?.content?.cloneNode(true);
      if (content) prepend ? target.prepend(content) : target.append(content);
    };
    insert('proof', buy, true);
    insert('heading', buy, true);
    insert('simple', chooser, true);
    insert('builder', builder, true);
    const open = root.querySelector('[data-modifit-open-simple]');
    open.textContent = story.querySelector('[data-mfc-simple]').dataset.buttonLabel || open.textContent;
    if (document.documentElement.dataset.mfBeltPreview === 'B') {
      const heading = buy.querySelector('.mfc-choice-title');
      const proof = buy.querySelector('.mfc-proof');
      if (heading) heading.textContent = story.dataset.testHeading;
      if (proof) proof.textContent = story.dataset.testProof;
      builder.inert = true;
      const step = story.querySelector('.mfc-process li p');
      if (step) step.textContent = story.dataset.testStep;
      const returnLink = story.querySelector('[data-mfc-return]');
      if (returnLink) returnLink.textContent = story.dataset.testReturn;
    
    }
    const price = main.querySelector('[data-block-type="price"] > .v-stack');
    if (price) insert('size', price);
    const gallery = main.querySelector('product-gallery');
    if (gallery) insert('badge', gallery);

    const title = main.querySelector('h1.product-title');
    if (title && /^Custom\s+/i.test(title.textContent.trim()) && !title.querySelector('.mfc-title-first')) {
      const remainder = title.textContent.trim().replace(/^Custom\s+/i, '');
      const first = document.createElement('span');
      first.className = 'mfc-title-first';
      first.textContent = 'Custom';
      const rest = document.createElement('span');
      rest.className = 'mfc-title-rest';
      rest.textContent = remainder;
      title.replaceChildren(first, document.createTextNode(' '), rest);
    }
    const carousel = gallery?.querySelector('.product-gallery__carousel');
    const frame = gallery?.querySelector('.product-gallery__carousel-with-arrows');
    const previous = frame?.querySelector('carousel-prev-button');
    const next = frame?.querySelector('carousel-next-button');
    if (carousel && frame && previous && next && !frame.querySelector('.mfc-gallery-nav')) {
      const navigation = document.createElement('div');
      navigation.className = 'mfc-gallery-nav';
      navigation.setAttribute('role', 'group');
      navigation.setAttribute('aria-label', 'Product gallery navigation');
      const counter = document.createElement('span');
      counter.className = 'mfc-gallery-count';
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      navigation.append(previous, counter, next);
      frame.append(navigation);
      let scheduled = false;
      const updateCounter = () => {
        scheduled = false;
        const slides = [...carousel.querySelectorAll('.product-gallery__media')].filter(slide => !slide.hidden && getComputedStyle(slide).display !== 'none');
        const bounds = carousel.getBoundingClientRect();
        const centre = bounds.left + bounds.width / 2;
        let closest = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs(rect.left + rect.width / 2 - centre);
          if (delta < distance) { distance = delta; closest = index; }
        });
        counter.textContent = String(slides.length ? closest + 1 : 0).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
        counter.setAttribute('aria-label', 'Item ' + (slides.length ? closest + 1 : 0) + ' of ' + slides.length);
        navigation.hidden = slides.length < 2;
      };
      const schedule = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(updateCounter); }
      };
      carousel.addEventListener('scroll', schedule, {passive:true});
      new ResizeObserver(schedule).observe(carousel);
      new MutationObserver(schedule).observe(carousel, {subtree:true, attributes:true, attributeFilter:['hidden','class','style']});
      schedule();
    }

    const list = main.querySelector('.product-info__block-list');
    const construction = story.querySelector('[data-mfc-construction]');
    const information = story.querySelector('[data-mfc-information]');
    let hasWhy = false;
    [...list.querySelectorAll('.product-info__block-item')].forEach(block => {
      if (block.querySelector('.modifit-why-card')) {
        if (!hasWhy) { construction.append(block); hasWhy = true; } else block.hidden = true;
      } else if (block.dataset.blockId === 'liquid_AFBeMi') {
        block.hidden = true;
      } else if (block.querySelector('.modifit-product-features')) {
        block.hidden = true;
      } else if (['accordion', 'description'].includes(block.dataset.blockType) || block.querySelector('.mf-custom-reassurance')) {
        information.append(block);
      }
    });
    insert('timing', list);
    story.querySelector('[data-mfc-return]').href = `#${main.id}`;
    root.querySelector('[data-modifit-simple-back]')?.addEventListener('click', () => {
      requestAnimationFrame(() => { open.focus({preventScroll:true}); buy.scrollIntoView({behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block:"center"}); });
    });
  };
  const run = () => document.querySelectorAll('[data-mfc-story]').forEach(story => { initialise(story); initialiseSizeGuide(story); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true}); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modifit-customer-photos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('modifit-photo-reviews')) {
  customElements.define('modifit-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.loadReviews();
    }
    async loadReviews() {
      const skus = [...new Set(this.dataset.skus.split(';').filter(Boolean))].join(';');
      if (!skus) return;
      const url = new URL('https://api.reviews.io/reviews');
      url.search = new URLSearchParams({store:'mobility-tools',type:'product_review',sku:skus,with:'images',per_page:'8',include_unpublished_photos:'false'});
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url, {signal:controller.signal,credentials:'omit'});
        if (!response.ok) return;
        const data = await response.json();
        const list = this.querySelector('.mfs-photos-list');
        const safePhoto = value => {
          try {
            const parsed = new URL(value);
            return parsed.protocol === 'https:' && parsed.hostname === 'media.reviews.co.uk' ? parsed.href : null;
          } catch (_) { return null; }
        };
        for (const review of (Array.isArray(data.reviews) ? data.reviews : []).slice(0,8)) {
          const photo = (review.photos || []).map(safePhoto).find(Boolean);
          if (!photo || review.type !== 'product_review') continue;
          const card = document.createElement('article');
          card.className = 'mfs-photo-card';
          card.setAttribute('role','listitem');
          const link = document.createElement('a');
          link.href = photo;
          link.target = '_blank';
          link.rel = 'noopener';
          const img = document.createElement('img');
          img.src = photo;
          img.alt = this.dataset.alt;
          img.width = 500;
          img.height = 500;
          img.loading = 'lazy';
          link.append(img);
          const copy = document.createElement('div');
          copy.className = 'mfs-photo-copy';
          const rating = Math.max(0,Math.min(5,Number(review.rating)||0));
          const stars = document.createElement('div');
          stars.textContent = '★'.repeat(Math.round(rating)) + '☆'.repeat(5-Math.round(rating));
          stars.setAttribute('aria-label',rating + ' ' + this.dataset.rating);
          copy.append(stars);
          const text = String(review.comments || '').trim();
          if (text.length > 180) {
            const details = document.createElement('details');
            const summary = document.createElement('summary');
            summary.textContent = text.slice(0,180) + '…';
            const rest = document.createElement('p');
            rest.textContent = text.slice(180);
            details.append(summary,rest);
            copy.append(details);
          } else if (text) {
            const quote = document.createElement('p');
            quote.textContent = text;
            copy.append(quote);
          }
          const author = document.createElement('div');
          author.className = 'mfs-photo-author';
          author.textContent = review.author?.name || this.dataset.author;
          copy.append(author);
          if ((review.tags || []).includes('incentivized')) {
            const disclosure = document.createElement('small');
            disclosure.textContent = this.dataset.incentive;
            copy.append(disclosure);
          }
          card.append(link,copy);
          list.append(card);
        }
        this.hidden = !list.children.length;
      } catch (_) {
        this.hidden = true;
      } finally { clearTimeout(timeout); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modifit-standard-style"]) return;
  try {
    
(() => {
  const initialise = () => {
    if (!document.querySelector('[data-mfs-gallery]')) return;
    const main = document.querySelector('.shopify-section--main-product');
    if (!main) return;
    main.querySelectorAll('product-gallery').forEach(gallery => {
      const frame = gallery.querySelector('.product-gallery__carousel-with-arrows');
      const carousel = gallery.querySelector('scroll-carousel');
      if (!frame || !carousel || frame.querySelector('.mfs-gallery-nav')) return;
      const previous = frame.querySelector('carousel-prev-button button');
      const next = frame.querySelector('carousel-next-button button');
      if (!previous || !next) return;
      const nav = document.createElement('div');
      nav.className = 'mfs-gallery-nav';
      const count = document.createElement('span');
      count.className = 'mfs-gallery-count';
      count.setAttribute('aria-live', 'off');
      const makeButton = (source, direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', source.textContent.trim());
        const icon = source.querySelector('svg');
        if (icon) button.appendChild(icon.cloneNode(true));
        button.addEventListener('click', () => direction < 0 ? carousel.previous() : carousel.next());
        return button;
      };
      const back = makeButton(previous, -1);
      const forward = makeButton(next, 1);
      nav.append(back, count, forward);
      frame.appendChild(nav);
      frame.classList.add('mfs-has-nav');
      const update = () => {
        const media = [...carousel.querySelectorAll('.product-gallery__media')].filter(item => !item.hidden && getComputedStyle(item).display !== 'none');
        nav.hidden = media.length < 2;
        if (!media.length) return;
        const rect = carousel.getBoundingClientRect();
        const centre = rect.left + rect.width / 2;
        let index = 0;
        let distance = Infinity;
        media.forEach((item, i) => {
          const box = item.getBoundingClientRect();
          const delta = Math.abs(box.left + box.width / 2 - centre);
          if (delta < distance) { index = i; distance = delta; }
        });
        const value = `${String(index + 1).padStart(2, '0')} / ${String(media.length).padStart(2, '0')}`;
        if (count.textContent !== value) count.textContent = value;
        back.disabled = media.length < 2;
        forward.disabled = media.length < 2;
      };
      let scheduled = false;
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; update(); });
      };
      carousel.addEventListener('scroll', schedule, {passive:true});
      new MutationObserver(schedule).observe(carousel, {subtree:true,attributes:true,attributeFilter:['hidden','class']});
      new ResizeObserver(schedule).observe(carousel);
      update();
    });
    if (!main.dataset.mfsObserved) {
      main.dataset.mfsObserved = 'true';
      new MutationObserver(() => {
        if ([...main.querySelectorAll('.product-gallery__carousel-with-arrows')].some(frame => !frame.querySelector('.mfs-gallery-nav'))) initialise();
      }).observe(main, {childList:true,subtree:true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();
})();
